const convertKnownFontWeight = (fontWeight) => {
  const fontWeightMap = {
    400: 'normal',
    700: 'bold',
  };

  return fontWeightMap[fontWeight] || fontWeight;
};

export const mapFabricFontToLocal = (selectedFont) =>
  window?.fonts?.find((font) => {
    const fabricFontFamily = selectedFont?.fontFamily?.toLowerCase();
    const fabricFontStyle = selectedFont?.fontStyle?.toLowerCase();
    const fabricWeight = convertKnownFontWeight(selectedFont?.fontWeight?.toLowerCase());

    const selectedFontFamily = font?.family?.toLowerCase();
    const selectedFontStyle = font?.style?.toLowerCase();
    const selectedWeight = convertKnownFontWeight(font?.weight?.toLowerCase());

    if (
      fabricFontFamily === selectedFontFamily &&
      fabricFontStyle === selectedFontStyle &&
      fabricWeight === selectedWeight
    ) {
      return font;
    }
    return false;
  });
